/**
 * SummaryCard Component
 * Reusable card component for summary sections
 */

import React from 'react';
import styled from 'styled-components';
import { Typography } from 'antd';

const { Title } = Typography;

const CardContainer = styled.div`
    background: ${props => {
        switch (props.variant) {
            case 'warning':
                return '#fffbe6';
            case 'success':
                return '#f6ffed';
            case 'metrics':
                return '#f0f5ff';
            default:
                return '#fafafa';
        }
    }};
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
    border: 1px solid ${props => {
        switch (props.variant) {
            case 'warning':
                return '#ffe58f';
            case 'success':
                return '#b7eb8f';
            case 'metrics':
                return '#adc6ff';
            default:
                return '#f0f0f0';
        }
    }};
`;

const CardHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
`;

const IconWrapper = styled.span`
    color: ${props => {
        switch (props.variant) {
            case 'warning':
                return '#faad14';
            case 'success':
                return '#52c41a';
            case 'metrics':
                return '#1890ff';
            default:
                return '#F16622';
        }
    }};
    font-size: 16px;
`;

const CardContent = styled.div`
    color: #333;
`;

/**
 * SummaryCard Component
 * @param {Object} props - Component props
 * @param {string} props.title - Card title
 * @param {React.ReactNode} props.icon - Icon element
 * @param {string} props.variant - Card variant (default, warning, success, metrics)
 * @param {React.ReactNode} props.children - Card content
 */
function SummaryCard({ title, icon, variant = 'default', children }) {
    return (
        <CardContainer variant={variant}>
            <CardHeader>
                {icon && (
                    <IconWrapper variant={variant}>
                        {icon}
                    </IconWrapper>
                )}
                <Title level={5} style={{ margin: 0, fontSize: 14 }}>
                    {title}
                </Title>
            </CardHeader>
            <CardContent>
                {children}
            </CardContent>
        </CardContainer>
    );
}

export default SummaryCard;
